import getSkillOptAdjReasons from '../helpers/getSkillOptAdjReasons'
import syncSkillCharacterSkillAdjsFromDetailEntries from '../helpers/syncSkillCharacterSkillAdjsFromDetailEntries'
//--------------------------------------------
// process calc count rebuild reason opt adjs
//--------------------------------------------
export default function processCalcCountRebuildReasonOptAdjs({ payload = {}, character = null }) {
  console.log('------------------------------------------')
  console.log('IN processCalcCountRebuildReasonOptAdjs')
  /*
  SUMMARY:
  --------
  This function is called from:
    - adj management view for optional adjs
    - NB: skill_adjs holds both applied & optional adjs altho here only optional adjs are being updated
  */
  //-----------
  // get parms
  //-----------
  const category = payload.category ? payload.category : ''
  const type = payload.type ? payload.type : ''
  const adjs = payload.data ? payload.data : {}

  console.log('category = ' + category + ' / type = ' + type)
  console.log('adjs = ', adjs)

  if (!character) {
    console.log('NO character passed in!')
    return null
  }
  //----------------------------------------------------------
  // park applied adjs so only optional adjs are processed here
  //----------------------------------------------------------
  let parkedAppliedAdjs = []
  if (category) {
    const adjsKey = `${category}_adjs`
    const allCategoryAdjs = character[adjsKey] || []
    parkedAppliedAdjs = allCategoryAdjs.filter((adj) => adj.applied === true)
    const optionalOnlyAdjs = allCategoryAdjs.filter((adj) => adj.applied === false)
    character[adjsKey] = optionalOnlyAdjs
    console.log(`0. parked applied ${adjsKey} = `, window.$deepCopy(parkedAppliedAdjs))
    console.log(`0a. working optional-only ${adjsKey} = `, window.$deepCopy(character[adjsKey]))
  }
  //-------------------
  // update skill adjs
  //-------------------
  character = _updateSkillAdjs({ adjs: adjs, category: category, type: type, character: character })
  console.log('1. UPDATED CHARACTER AFTER ADJS UPDATE = ', window.$deepCopy(character))
  console.log(`2. character[${category}_adjs] = `, window.$deepCopy(character[`${category}_adjs`]))
  //=============================================================================================
  // ONLY APPLICABLE TO SKILLS ADJS AT THIS TIME [ONLY CONSIDER APPLIED = FALSE = OPTIONAL ADJS]
  //=============================================================================================
  if (category == 'skill') {
    console.log('3. processing skill adjs for type = ' + type)
    console.log('4. character skills = ', character.skills)
    let matching_skills = []
    //-----------------------------------------------
    // A. runecasting (ensure active rune for skill)
    //-----------------------------------------------
    if (type.includes('Rune')) {
      console.log('5. processing runecasting skill matching by display_name = type = ', type)
      matching_skills = character.skills.filter((s) => {
        const matchesRuneName = s.display_name === type
        if (!matchesRuneName) {
          return false
        }
        //---------------------------------------------
        // only match where associated rune is active
        //---------------------------------------------
        const active_rune =
          character.runes && character.runes.length > 0
            ? character.runes.find((r) => r.name === s.display_name && r.active === true)
            : null
        return !!active_rune
      })
      //-------------------------------------------------------------------------------
      // B. default: match by name (covers both 'normal' skills [should only get only]
      //-------------------------------------------------------------------------------
    } else {
      console.log('6. processing default matching by name = ', type)
      matching_skills = character.skills.filter((s) => s.name === type)
    }
    console.log('=============================================================================')
    console.log('7. matching_skills = ', matching_skills)
    //---------------------
    // got matching skills
    //---------------------
    if (matching_skills && matching_skills.length > 0) {
      console.log('8. got matching skill count = ', matching_skills.length)
      //--------------------
      // loop matching skills
      //---------------------
      matching_skills.forEach((skill) => {
        console.log('=============================================================================')
        console.log('9. processing skill = ', window.$deepCopy(skill))
        //--------------------------
        // update skill adjs totals
        //--------------------------
        skill = _updateSkillOptAdjCount({ category, type, skill, character })
        console.log('10. updated skill with adjs totals = ', window.$deepCopy(skill))
        console.log('11. character skills_adjs = ', window.$deepCopy(character[`${category}_adjs`]))
        //-------------------------------
        // update skill opt adjs reasons
        //-------------------------------
        skill = _updateSkillOptAdjReasons({ category, type, skill, character })
        console.log('12. updated skill with opt adjs reasons = ', window.$deepCopy(skill))
        //-------------------------------------------
        // trigger Vue reactivity with new array ref
        // ------------------------------------------
        let idx = character.skills.findIndex((s) => s.id === skill.id)
        if (idx !== -1) {
          character.skills[idx] = skill
        }
      })
      console.log('13. character skills = ', window.$deepCopy(character.skills))
    }
    //=====================================================================
    // B. where NON-SKILL category
    //=====================================================================
  } else {
    console.error('SHOULD NOT BE IN processCalcCountRebuildReasonOptAdjs for type = ' + type)
  }
  //-------------------------------------------------
  // re-attach parked applied adjs (if any were parked)
  //-------------------------------------------------
  if (category && parkedAppliedAdjs.length > 0) {
    const adjsKey = `${category}_adjs`
    const optionalNow = character[adjsKey] || []
    character[adjsKey] = [...parkedAppliedAdjs, ...optionalNow]
    console.log(`14. re-attached applied ${adjsKey} = `, window.$deepCopy(parkedAppliedAdjs))
    console.log(`14a. final ${adjsKey} = `, window.$deepCopy(character[adjsKey]))
  }

  if (category === 'skill') {
    syncSkillCharacterSkillAdjsFromDetailEntries(character)
  }
  console.log('14b. updated character following all adjs = ', window.$deepCopy(character))
  //--------------------------
  // return mutated character
  //--------------------------
  return character
  //=================================================================================
  // INTERNAL FUNCTION: update skill adjs
  // -------------------------------------
  function _updateSkillAdjs({ adjs, category, type, character }) {
    console.log('IN _updateSkillAdjs for category = ' + category + ' / type = ' + type)
    console.log('1. adjs = ', window.$deepCopy(adjs))
    //----------------------------------------------------------------------------------
    // remove all skill adjs for this specific type/skill (applied adjs already parked)
    //----------------------------------------------------------------------------------
    // NB: but this could leave runecasting adjs for this skill
    // So need to check adjs being added below to ensure no duplicates
    //----------------------------------------------------------------------------------
    character[`${category}_adjs`] = character[`${category}_adjs`].filter((adj) => adj.name !== type)
    console.log(
      `2. character[${category}_adjs] AFTER removal = `,
      window.$deepCopy(character[`${category}_adjs`]),
    )
    //---------------------------------------------------------
    // add updated adjs impacted category (i.e. for this type) [could be empty if no adjs/adjs removed]
    //---------------------------------------------------------
    if (adjs && adjs.length > 0) {
      console.log(`3. Adding new adjs to character[${category}_adjs] = `, window.$deepCopy(adjs))
      //--------------------------
      // loop adjs for this skill
      //--------------------------
      adjs.forEach((a) => {
        console.log('4. Checking adj to add = ', window.$deepCopy(a))
        //----------------------------------------------------
        // check exists (prevent dupes) e.g. runecasting adjs
        //----------------------------------------------------
        const exists = character[`${category}_adjs`].some(
          (existing_adj) =>
            existing_adj.name === a.name && existing_adj.adj_reason === a.adj_reason,
        )
        //-----------------------
        // already exists - skip
        //-----------------------
        if (exists) {
          console.log('5. Adj already exists - skipping addition = ', window.$deepCopy(a))
          //----------------------
          // does not exist - add
          //----------------------
        } else {
          console.log('6. Adj does not exist - adding = ', window.$deepCopy(a))
          character[`${category}_adjs`].push(window.$deepCopy(a))
        }
      })
    }
    console.log(
      `7. character[${category}_adjs] AFTER addition = `,
      window.$deepCopy(character[`${category}_adjs`]),
    )
    //--------------------------------------
    // return updated character for clarity
    //--------------------------------------
    return character
  }
  //=================================================================================
  // INTERNAL FUNCTION: update skill adjs count
  // -------------------------------------------
  function _updateSkillOptAdjCount({ category, type, skill, character }) {
    console.log('--------------------------')
    console.log('IN _updateSkillOptAdjCount')
    console.log('1. category = ' + category + ' / type = ' + type)
    console.log('2. skill = ', skill)
    console.log('4. character = ', character)
    console.log('5. character skill_adjs = ', character[`${category}_adjs`])

    const adjs_cnt_opt = character[`${category}_adjs`].filter((adj) => adj.name === type).length
    console.log('>>>> optional adj count for type = ', type, ' = ', adjs_cnt_opt)
    //---------------------------------------------------------------------------
    // check if adj count properties exist - if not, create new object with them
    //---------------------------------------------------------------------------
    if (!('adjs_cnt_opt' in skill)) {
      console.log('Creating new skill object with adj properties')
      return { ...skill, adjs_cnt_opt: adjs_cnt_opt }
    }
    //---------------------------------
    // update skill with opt adj count
    //---------------------------------
    skill.adjs_cnt_opt = adjs_cnt_opt
    //----------------------
    // return updated skill
    //----------------------
    console.log('UPDATED skill in _updateSkillOptAdjCount = ', skill)
    return skill
  }
  //=================================================================================
  // INTERNAL FUNCTION: update skill adjs reasons
  // ---------------------------------------------
  function _updateSkillOptAdjReasons({ category, type, skill, character }) {
    console.log('--------------------------')
    console.log('IN _updateSkillOptAdjReasons')
    console.log('category = ' + category + ' / type = ' + type)
    console.log('skill = ', skill)

    const reasons = getSkillOptAdjReasons({
      adjs: character[`${category}_adjs`],
      skill: skill,
      type: type,
    })
    console.log('>>>> return skill reasons = ', reasons)
    //----------------------------------------------------------------
    // check if adj props exist - if not, create new object with them
    //----------------------------------------------------------------
    if (!('adjs_reasons_character_skill_opt' in skill)) {
      console.log('Creating new skill object with adj reason properties')
      return {
        ...skill,
        adjs_reasons_character_skill_opt: reasons,
      }
    }
    //-------------------------------
    // update skill with adj reasons
    //-------------------------------
    skill.adjs_reasons_character_skill_opt = reasons
    //----------------------
    // return updated skill
    //----------------------
    return skill
  }
}
